import type { Template } from "@/types";

export const PO_07_H2_V5: Template[] = [
    {
        id: "po-07-h2v5-01",
        name: "PO 01 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_01.png",
        size: [1311, 820],
        style: {},
        slots: [         
            { id: "1", x: 48, y: 227, width: 292, height: 180, rotation: 0, imageRotation: 0 },
            { id: "2", x: 48, y: 415, width: 292, height: 179, rotation: 0, imageRotation: 0 },
            { id: "3", x: 348, y: 227, width: 259, height: 367, rotation: 0, imageRotation: 0 },
            { id: "4", x: 758, y: 102, width: 222, height: 305, rotation: 0, imageRotation: 0 },
            { id: "5", x: 758, y: 415, width: 222, height: 305, rotation: 0, imageRotation: 0 },
            { id: "6", x: 988, y: 102, width: 221, height: 305, rotation: 0, imageRotation: 0 },
            { id: "7", x: 988, y: 415, width: 221, height: 305, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-02",
        name: "PO 02 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_02.png",
        size: [1311, 820],
        style: {},
        slots: [        
            { id: "1", x: 48, y: 227, width: 292, height: 180, rotation: 0, imageRotation: 0 },
            { id: "2", x: 48, y: 415, width: 292, height: 179, rotation: 0, imageRotation: 0 },
            { id: "3", x: 348, y: 227, width: 259, height: 367, rotation: 0, imageRotation: 0 },
            { id: "4", x: 710, y: 154, width: 412, height: 514, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1129, y: 154, width: 124, height: 166, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1129, y: 328, width: 124, height: 166, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1129, y: 502, width: 124, height: 166, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-03",
        name: "PO 03 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_03.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 67, y: 147, width: 518, height: 257, rotation: 0, imageRotation: 0 },
            { id: "2", x: 67, y: 411, width: 352, height: 226, rotation: 0, imageRotation: 0 },
            { id: "3", x: 426, y: 411, width: 159, height: 226, rotation: 0, imageRotation: 0 },
            { id: "4", x: 678, y: 147, width: 393, height: 490, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1078, y: 146, width: 118, height: 159, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1078, y: 312, width: 118, height: 159, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1078, y: 478, width: 118, height: 158, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-04",
        name: "PO 04 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 68, y: 147, width: 397, height: 242, rotation: 0, imageRotation: 0 },
            { id: "2", x: 68, y: 396, width: 397, height: 241, rotation: 0, imageRotation: 0 },
            { id: "3", x: 472, y: 147, width: 114, height: 159, rotation: 0, imageRotation: 0 },
            { id: "4", x: 472, y: 313, width: 114, height: 159, rotation: 0, imageRotation: 0 },
            { id: "5", x: 472, y: 479, width: 114, height: 158, rotation: 0, imageRotation: 0 },
            { id: "6", x: 680, y: 207, width: 256, height: 370, rotation: 0, imageRotation: 0 },
            { id: "7", x: 943, y: 207, width: 255, height: 370, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-05",
        name: "PO 05 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 56, y: 205, width: 265, height: 375, rotation: 0, imageRotation: 0 },
            { id: "2", x: 328, y: 205, width: 245, height: 184, rotation: 0, imageRotation: 0 },
            { id: "3", x: 328, y: 396, width: 245, height: 184, rotation: 0, imageRotation: 0 },
            { id: "4", x: 678, y: 147, width: 393, height: 490, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1078, y: 147, width: 118, height: 159, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1078, y: 313, width: 118, height: 159, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1078, y: 479, width: 118, height: 158, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-06",
        name: "PO 06 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 91, y: 153, width: 162, height: 236, rotation: 0, imageRotation: 0 },
            { id: "2", x: 91, y: 396, width: 162, height: 235, rotation: 0, imageRotation: 0 },
            { id: "3", x: 260, y: 153, width: 161, height: 236, rotation: 0, imageRotation: 0 },
            { id: "4", x: 260, y: 396, width: 161, height: 235, rotation: 0, imageRotation: 0 },
            { id: "5", x: 428, y: 153, width: 344, height: 478, rotation: 0, imageRotation: 0 },
            { id: "6", x: 779, y: 153, width: 383, height: 236, rotation: 0, imageRotation: 0 },
            { id: "7", x: 779, y: 396, width: 383, height: 235, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-07",
        name: "PO 07 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_07.png",
        size: [1311, 820],
        style: {},
        slots: [                  
            { id: "1", x: 94, y: 160, width: 170, height: 247, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 272, y: 160, width: 169, height: 247, rotation: 0, imageRotation: 0 },
            { id: "3", x: 449, y: 160, width: 401, height: 247, rotation: 0, imageRotation: 0 },
            { id: "4", x: 94, y: 415, width: 401, height: 246, rotation: 0, imageRotation: 0 },
            { id: "5", x: 503, y: 415, width: 170, height: 246, rotation: 0, imageRotation: 0 },       
            { id: "6", x: 681, y: 415, width: 169, height: 246, rotation: 0, imageRotation: 0 },
            { id: "7", x: 858, y: 160, width: 360, height: 501, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-08",
        name: "PO 08 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_08.png",
        size: [1311,820],
        style: {},
        slots: [
            { id: "1", x: 0, y: 265, width: 201, height: 290, rotation: 0, imageRotation: 0 },
            { id: "2", x: 209, y: 265, width: 201, height: 290, rotation: 0, imageRotation: 0 },
            { id: "3", x: 418, y: 265, width: 475, height: 290, rotation: 0, imageRotation: 0 },
            { id: "4", x: 901, y: 265, width: 201, height: 290, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1110, y: 265, width: 201, height: 141, rotation: 0, imageRotation: 0 }, 
            { id: "6", x: 1110, y: 414, width: 97, height: 141, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1215, y: 414, width: 97, height: 141, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-09",
        name: "PO 09 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_09.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 91, y: 153, width: 162, height: 236, rotation: 0, imageRotation: 0 },
            { id: "2", x: 91, y: 396, width: 162, height: 235, rotation: 0, imageRotation: 0 },
            { id: "3", x: 260, y: 153, width: 161, height: 236, rotation: 0, imageRotation: 0 },
            { id: "4", x: 260, y: 396, width: 161, height: 235, rotation: 0, imageRotation: 0 },
            { id: "5", x: 428, y: 153, width: 383, height: 236, rotation: 0, imageRotation: 0 },
            { id: "6", x: 428, y: 396, width: 383, height: 235, rotation: 0, imageRotation: 0 },
            { id: "7", x: 818, y: 153, width: 344, height: 478, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-10",
        name: "PO 10 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_10.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 78, y: 0, width: 621, height: 388, rotation: 0, imageRotation: 0 },
            { id: "2", x: 78, y: 395, width: 621, height: 388, rotation: 0, imageRotation: 0 },
            { id: "3", x: 706, y: 0, width: 190, height: 256, rotation: 0, imageRotation: 0 },
            { id: "4", x: 706, y: 263, width: 190, height: 256, rotation: 0, imageRotation: 0 },
            { id: "5", x: 706, y: 527, width: 190, height: 256, rotation: 0, imageRotation: 0 },
            { id: "6", x: 904, y: 0, width: 270, height: 389, rotation: 0, imageRotation: 0 },
            { id: "7", x: 904, y: 396, width: 270, height: 388, rotation: 0, imageRotation: 0 }
        ],
    }
];